import macbookImage from 'assets/images/macbook.png';
import iphoneImage from 'assets/images/iphone.png';
import macbookContentImage from 'assets/images/home/macbook-content.jpg';
import iphoneContentImage from 'assets/images/home/iphone-content.jpg';
import purpleStripeImage from 'assets/images/home/schedule.png';

const purpleStripeSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3492.39 714.88"><defs><linearGradient id="purpleStripeGradient" x1="171.23" y1="663.06" x2="3751.2" y2="663.06" gradientTransform="matrix(3.03, -0.12, -0.07, 1.15, -3726.05, -124.39)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff" /><stop offset="0.52" stop-color="#c1b0fc" /></linearGradient></defs><path fill="url(#purpleStripeGradient)" d="M506,372.84,0,677.39l3382.89,37.48L3492.39,0Z" /></svg>';

export default theme => ({
  // Main section
  mainSection: {
    minHeight: 468,
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
      paddingTop: theme.spacing.unit * 15
    },
    [theme.breakpoints.down('lg')]: {
      paddingTop: theme.spacing.unit * 5
    }
  },
  mainSectionText: {
    [theme.breakpoints.up('lg')]: {
      position: 'relative',
      zIndex: 2
    },
    [theme.breakpoints.up('sm')]: {
      whiteSpace: 'pre-wrap',
    },
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing.unit * 5
    }
  },
  mainSectionTextTitle: {
    font: '300 42px/50px "Open Sans"',
    marginBottom: theme.spacing.unit * 2
  },
  mainSectionTextDescription: {
    font: '300 21px/24px "Open Sans"',
    marginBottom: theme.spacing.unit * 5
  },
  mainSectionMacbook: {
    width: 700,
    height: 408,
    maxWidth: '100%',
    overflow: 'hidden',
    background: {
      image: `url("${macbookImage}")`,
      size: 'cover',
      repeat: 'no-repeat',
      position: 'left center'
    },
    [theme.breakpoints.up('lg')]: {
      position: 'absolute',
      top: 60,
      left: '50%',
      marginLeft: -80,
      zIndex: 1
    },
    [theme.breakpoints.down('lg')]: {
      position: 'relative',
      margin: 'auto'
    },
    '&:before': {
      width: 501,
      height: 314,
      display: 'block',
      content: '""',
      position: 'absolute',
      left: 102,
      top: 34,
      background: {
        image: `url(${macbookContentImage})`,
        repeat: 'no-repeat',
        size: 'cover'
      }
    }
  },
  mainSectionIphone: {
    width: 162,
    height: 319,
    position: 'absolute',
    right: 5,
    bottom: 0,
    background: {
      image: `url("${iphoneImage}")`,
      size: 'contain',
      repeat: 'no-repeat',
    },
    '&:before': {
      width: 133,
      height: 237,
      display: 'block',
      content: '""',
      position: 'absolute',
      left: 15,
      top: 39,
      background: {
        image: `url(${iphoneContentImage})`,
        repeat: 'no-repeat',
        size: 'cover'
      }
    }
  },
  // Purple stripe
  purpleStripe: {
    background: {
      image: `url('data:image/svg+xml;utf8,${encodeURIComponent(purpleStripeSvg)}')`,
      size: 'cover'
    },
    marginTop: -200,
    padding: '300px 0 100px',
    [theme.breakpoints.up('lg')]: {
      backgroundPosition: 'center center'
    },
    [theme.breakpoints.down('lg')]: {
      backgroundPosition: '60% center'
    }
  },
  purpleStripeInner: {
    [theme.breakpoints.up('lg')]: {
      width: 1160,
      margin: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      flexDirection: 'row-reverse'
    }
  },
  purpleStripeContainer: {
    [theme.breakpoints.up('lg')]: {
      width: 'auto',
      margin: 0
    }
  },
  purpleStripeText: {
    [theme.breakpoints.up('lg')]: {
      width: 500,
    },
    [theme.breakpoints.up('sm')]: {
      whiteSpace: 'pre-wrap'
    },
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing.unit * 5
    }
  },
  purpleStripeTextTitle: {
    font: '300 30px/35px "Open Sans"',
    color: '#fff',
    marginBottom: theme.spacing.unit * 2
  },
  purpleStripeTextDescription: {
    font: '300 17px/21px "Open Sans"',
    color: '#fff',
    marginBottom: theme.spacing.unit * 5
  },
  purpleStripeTextButton: {
    backgroundColor: 'transparent',
    border: '2px solid #fff',
    borderRadius: 2,
    color: '#fff',
    display: 'inline-block',
    height: 36,
    lineHeight: '32px',
    padding: `0 ${theme.spacing.unit * 2}px`,
    textTransform: 'uppercase',
    transitionProperty: 'border-color, background-color',
    transitionDuration: theme.transitions.duration.short,
    transitionTimingFunction: theme.transitions.easing.easeIn,
    '&:hover': {
      backgroundColor: theme.palette.primary['500'],
      borderColor: 'transparent'
    }
  },
  purpleStripeImage: {
    overflow: 'hidden'
  },
  purpleStripeImageInner: {
    width: 501,
    height: 163,
    margin: 'auto',
    background: {
      image: `url(${purpleStripeImage})`,
      size: 'cover'
    }
  },
  // Features
  features: {
    paddingTop: theme.spacing.unit * 5
  },
  featuresTitle: {
    font: '300 30px/35px "Open Sans"',
    marginBottom: theme.spacing.unit * 5,
    [theme.breakpoints.up('lg')]: {
      textAlign: 'center'
    },
    [theme.breakpoints.up('sm')]: {
      whiteSpace: 'pre-wrap'
    }
  },
  feature: {
    height: '100%',
    position: 'relative',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 200,
      margin: 'auto',
      whiteSpace: 'pre-wrap'
    }
  },
  featureIcon: {
    width: 30,
    height: 30,
    marginBottom: theme.spacing.unit * 2,
    '& > svg': {
      strokeWidth: 2
    }
  },
  featureTitle: {
    font: '300 16px/18px "Open Sans"',
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing.unit * 3
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing.unit * 2
    }
  },
  featureDescription: {
    fontWeight: 300
  },
  featureLink: {
    marginTop: theme.spacing.unit * 5,
    '& > a': {
      font: '300 11px/13px "Open Sans"',
      position: 'absolute',
      bottom: 0,
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  },
  // Footer
  footer: {
    marginTop: theme.spacing.unit * 5,
    paddingTop: theme.spacing.unit * 8,
    paddingBottom: theme.spacing.unit * 3,
    backgroundImage: 'linear-gradient(to right, #b5e4fc 42%, #1ad3ff 92%)',
    [theme.breakpoints.up('lg')]: {
      textAlign: 'center'
    }
  },
  footerTitle: {
    font: '300 30px/35px "Open Sans"',
    color: '#4A4A4A',
    marginBottom: theme.spacing.unit * 5
  },
  footerDescription: {
    font: '300 21px/24px "Open Sans"',
    color: '#4A4A4A',
    marginBottom: theme.spacing.unit * 5,
    [theme.breakpoints.up('sm')]: {
      whiteSpace: 'pre-wrap'
    }
  },
  footerButton: {
    backgroundColor: 'transparent',
    border: '2px solid #6E40DD',
    borderRadius: 2,
    color: '#6E40DD',
    display: 'inline-block',
    height: 36,
    lineHeight: '32px',
    padding: `0 ${theme.spacing.unit * 2}px`,
    transitionProperty: 'border-color, background-color, color',
    transitionDuration: theme.transitions.duration.short,
    transitionTimingFunction: theme.transitions.easing.easeIn,
    '&:hover': {
      color: '#fff',
      backgroundColor: '#6E40DD',
      borderColor: 'transparent'
    }
  },
  footerMenu: {
    paddingTop: theme.spacing.unit * 14,
    [theme.breakpoints.up('lg')]: {
      textAlign: 'right'
    }
  }
});



// WEBPACK FOOTER //
// ./src/pages/Home/styles.js